import { useContext } from 'react';
import WorkspaceContext from './WorkspaceContext';

/**
 * Custom hook to consume the WorkspaceContext.
 * Throws an error if used outside a WorkspaceProvider.
 */
export const useWorkspace = () => {
  const context = useContext(WorkspaceContext);
  if (!context) {
    throw new Error('useWorkspace must be used within a WorkspaceProvider');
  }
  return context;
};

export default useWorkspace;
